<template>
    <transition name="modal">
        <div class="modal-mask sub-form">
            <div class="modal-wrapper">
                <div class="notification-modal-container">
                    <center>
                        <div v-if="isWarning">
                            <img class="notification-icon" src="../assets/images/caution.png" />
                            <br/>
                        </div>
                        
                        <div v-if="isError">
                            <img class="notification-icon" src="../assets/images/error.png" />
                            <br/>
                        </div>
                        
                        <div v-if="isSuccess">
                            <img class="notification-icon" src="../assets/images/success.png" />
                            <br/>
                        </div>

                        <div class="message-title"><b>{{ messageTitle }}</b></div>
                        <div class='modal-message' v-html="message"></div>
                        <br/>
                    
                        <div>
                            <button class="button is-link modal-button first-button" v-if="isFirstAction" @click="firstActionMethod" v-html="firstActionText"></button>
                            <button class="button modal-button second-button" v-if="isSecondAction" @click="secondActionMethod" v-html="secondActionText"></button>
                        </div>

                    </center>
                </div>  
            </div>
        </div>
    </transition>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
    props: {
        vuexStore: null,
        messageTitle: null,
        message: null,
        firstAction: null,  // can be set to 'close' for closing modal only. Assign an action if needed to do something else.
        firstActionText: null,
        secondAction: null, // can be set to 'close' for closing modal only.
        secondActionText: null,
        notificationType: null,
        resetVariable: null,

    },

    data () {
        return {
            isWarning: (this.notificationType == 'warning') ? true : false,
            isError: (this.notificationType == 'error') ? true : false,
            isSuccess: (this.notificationType == 'success') ? true : false,

            isFirstAction: (this.firstAction != null) ? true : false,
            isSecondAction: (this.secondAction != null) ? true : false,
        }
    },
    
    computed: {
    },

    methods:{
        reset: function(){
            VueStore.dispatch('notify/setShowMessage', {key: this.resetVariable, bool: false});
            
            // determine which modal allow datatable to refresh
            var refreshList = ['showCancelRequestSuccess','showRequestReceived','showInterpreterSecured','showInterpreterNotAvailable','showInterpreterReplaced', 'showRequestCancelled', 'showUploadFileSuccess', 'showDeleteFileSuccess'];

            if($.inArray(this.resetVariable, refreshList) != -1){
                VueStore.dispatch('datatable/resetDatatable'); //reload datatable
            } else {
                //console.log("no refresh");
            }
            
        },

        firstActionMethod: function(){
            if(this.vuexStore != null && this.firstAction != null){
                if(this.firstAction !== 'close'){
                    VueStore.dispatch(this.vuexStore + '/' + this.firstAction);
                }
            }
            this.reset();
        },

        secondActionMethod: function(){
            if(this.vuexStore != null && this.secondAction != null){
                if(this.secondAction !== 'close'){
                    VueStore.dispatch(this.vuexStore + '/' + this.secondAction);
                }
            }
            
            this.reset();
        },

    },

    created(){
    },

    mounted(){
        
    }
}
</script>

<style scoped>
body{
  overflow-y: auto;  
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
    display: table-cell;
    top: 170px;
    position: relative;
    height: 100%;
  
}

.notification-modal-container {
  width: 450px;
  /*height: 200px;*/
  margin: 0px auto;
  padding: 20px 10px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body, .modal-footer{
  margin: 0px;
  background: #FFFFFF;
}

.modal-default-button {
  float: right;
}



.notification-icon{
    width: 35px;
    height: 35px;
    margin-bottom: 10px;
}

.modal-message{
    text-align: center;
    font-size:14px;
}

.message-title{
    margin-bottom: 5px;
}

center{
    padding: 5px;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter-from {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter-from .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>